import { C } from "../constants";
import { Sec, STitle, Btn } from "../components/Shared";

export default function Pricing() {
  return (
    <Sec>
      <STitle tag="Pricing" title="Simple, transparent pricing" sub="Choose the plan that's right for your needs" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))", gap: 22, maxWidth: 620, margin: "0 auto" }}>
        {[
          { name: "Basic", price: "7.99", period: "/month", desc: "Oversight for a single user",
            features: ["Up to 2 users", "1 approver", "AI kindness filter", "Contact approval", "Smart rewrites", "Email alerts"], pop: false },
          { name: "Plus", price: "14.99", period: "/month", desc: "Oversight for multiple users",
            features: ["Up to 5 managed users", "1 approver", "Everything in Basic", "Priority AI filtering", "Wellbeing insights", "Phone & email support"], pop: true },
        ].map((p, i) => (
          <div key={i} style={{
            background: C.white, borderRadius: 18, padding: 32, display: "flex", flexDirection: "column",
            border: p.pop ? `2px solid ${C.blue}` : `1px solid ${C.border}`, position: "relative"
          }}>
            {p.pop && <div style={{
              position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)",
              background: `linear-gradient(90deg, ${C.blue}, ${C.blueDark})`, color: "#fff",
              fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 11.5,
              padding: "4px 16px", borderRadius: 10, letterSpacing: 0.5
            }}>MOST POPULAR</div>}
            <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 21, color: C.text, margin: "0 0 4px" }}>{p.name}</h3>
            <p style={{ fontFamily: "'Nunito', sans-serif", color: C.textLight, fontSize: 13.5, margin: "0 0 18px" }}>{p.desc}</p>
            <div style={{ marginBottom: 22 }}>
              <span style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: 38, color: C.text }}>
${p.price}
              </span>
              <span style={{ fontFamily: "'Nunito', sans-serif", color: C.textLight, fontSize: 14 }}>{p.period}</span>
            </div>
            <div style={{ flex: 1 }}>
              {p.features.map((f, j) => (
                <div key={j} style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 11 }}>
                  <span style={{ color: C.accent, fontSize: 15, fontWeight: 700 }}>✓</span>
                  <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: 13.5, color: C.textMid }}>{f}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 8 }}>
              <a href="https://apps.apple.com/app/id6789908989" target="_blank" rel="noopener noreferrer" style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                background: "#000", color: "#fff", borderRadius: 10,
                padding: "10px 16px", textDecoration: "none", fontSize: 13,
                fontFamily: "'Nunito', sans-serif", fontWeight: 600
              }}>
                <span style={{ fontSize: 18 }}>&#63743;</span>
                <span>Download on the App Store</span>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.dogmatech.safezapp" target="_blank" rel="noopener noreferrer" style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                background: "#000", color: "#fff", borderRadius: 10,
                padding: "10px 16px", textDecoration: "none", fontSize: 13,
                fontFamily: "'Nunito', sans-serif", fontWeight: 600
              }}>
                <span style={{ fontSize: 16 }}>▶</span>
                <span>GET IT ON Google Play</span>
              </a>
            </div>
          </div>
        ))}
      </div>
      <p style={{ textAlign: "center", fontFamily: "'Nunito', sans-serif", color: C.textLight, fontSize: 13.5, marginTop: 28 }}>
        All plans include a 30-day free trial. No obligation, no credit card required.
      </p>

    </Sec>
  );
}
